<template>
  <div class="cargo-detail">
    <div>
      <el-form
        v-if="operationType!==2"
        ref="cargoDetalilFilter"
        :model="form"
        label-width="90px"
        @submit.native.prevent
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              label="包装号"
              prop="packageNo"
            >
              <el-input v-model="form.packageNo" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="订单号"
              prop="poNos"
            >
              <cargo-multi-line-text-popover
                ref="poInput"
                input-width="100%"
                :value.sync="form.poNos"
                show-popover
                :visible-arrow="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="SKU号"
              prop="itemNo"
            >
              <el-input v-model="form.itemNo" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="生产商"
              prop="producerName"
            >
              <el-input v-model="form.producerName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="()=>handleQuery(1)"
              >搜索</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <div
        v-if="operationType===1"
        class="trigger"
        style="flex:1"
      >
        <el-form>
          <el-button
            type="primary"
            @click="addCargoVisible=true"
          >加入货物</el-button>
          <el-button
            type="primary"
            @click="handleRemovePackage"
          >移除货物</el-button>
          <el-button
            type="primary"
            @click="oneKeyIncomeVisible=true"
          >一键进仓</el-button>
          <el-button
            type="primary"
            @click="handleWarehousIn"
          >单箱进仓</el-button>
          <el-button
            type="primary"
            @click="packageImportVisible=true"
          >批量进仓</el-button>
          <el-button
            type="primary"
            @click="clearPackageIncome"
          >清除进仓信息</el-button>
        </el-form>
      </div>
      <div
        v-if="sumInfo && operationType!==2"
        style="display:flex;align-items:center"
      >
        <div
          :class="['total',form.eqFlag?'notEq':'' ]"
          @click="totalClick"
        >总包装数:{{ sumInfo.sumEstimatedQuantity }}/<span :style="{color:sumInfo.sumEstimatedQuantity===sumInfo.sumQuantity?'':'red'}">{{ sumInfo.sumQuantity }}</span></div>
        <div style="margin:0 10px">总体积(CBM):{{ sumInfo.sumEstimatedCubage }}/{{ sumInfo.sumCubage }}</div>
        <div>总重量(KGS):{{ sumInfo.sumEstimatedGrossWeight }}/{{ sumInfo.sumGrossWeight }}</div>
      </div>
    </div>
    <div>
      <cargo-ag-grid
        ref="goodsTable"
        config-module="701002"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 400px"
      />
    </div>
    <div>
      <el-form>
        <cargo-pagination
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="()=>handleQuery()"
        />
      </el-form>
    </div>
    <add-cargo
      :visible="addCargoVisible"
      :warehouse-in-uuid="warehouseInUuid"
      @onClose="handleAddCargoClose"
    />
    <warehousing-dialog
      :visible="warehousingVisible"
      :warehouse-in-detail-uuid="editRow?editRow.warehouseInDetailUuid : null"
      :package-uuid="editRow?editRow.uuid : null"
      @onClose="handleWarehousingClose"
    />
    <one-key-income
      :visible="oneKeyIncomeVisible"
      :warehouse-in-uuid="warehouseInUuid"
      @onClose="oneKeyIncomeClose"
    />
    <import-dialog
      title="批量导入进仓数据"
      :action="`${URL.warehouseIn.batchIncome}?warehouseInUuid=${warehouseInUuid}`"
      :visible="packageImportVisible"
      :warehouse-in-uuid="warehouseInUuid"
      @onClose="importDialogClose"
      @handleExport="exportTemplate"
    />
  </div>
</template>
<script>
import URL from '@/api/urlTranslator'
import {
  queryWarehouseInDetailPageable,
  queryPoPackageSumInfo,
  removePackageFromWarehouseIn,
  clearPackageIncome, exportNeedWarehouseInPackage
} from '@/api/OMS/warehouseIn'
import addCargo from './addCargo'
import oneKeyIncome from './oneKeyIncome'
import warehousingDialog from './warehousingDialog'
import importDialog from './importDialog'
import cargoMultiLineTextPopover from '@/components/Cargo/Common/cargoMultiLineTextPopover'
import { getLoading } from '@/utils/utilBaseElement'
import { formatRoundNumber } from '@/utils/NumberUtils'
import convertResToBlob from '@/utils/convertResToBlob'
export default {
  name: 'CargoDetail',
  components: {
    addCargo,
    warehousingDialog,
    cargoMultiLineTextPopover,
    oneKeyIncome,
    importDialog
  },
  props: {
    operationType: {
      type: Number,
      default: () => 2
    },
    warehouseInUuid: { type: String, default: () => '' },
    refreshBaseInfo: { type: Function, default: () => {} }
  },
  data() {
    return {
      URL,
      addCargoVisible: false,
      oneKeyIncomeVisible: false,
      warehousingVisible: false,
      packageImportVisible: false,
      form: {
        packageNo: '',
        poNos: '',
        itemNo: '',
        producerName: '',
        eqFlag: ''
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.rowDoubleClicked
      },
      gridParams: {},
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: (item) => {
            const { data } = item
            if (!data.packageNo) {
              return false
            }
            return true
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '包装号',
          colId: 'packageNo',
          field: 'packageNo',
          width: 150
        },
        {
          headerName: '包装类型',
          colId: 'packageType',
          field: 'packageType',
          width: 150
        },
        {
          headerName: '包装数(预/实)',
          colId: 'quantity',
          field: 'quantity',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedQuantity}</span>/<span ${
              data.quantity !== data.estimatedQuantity ? 'style="color:red' : ''
            }">${data.quantity}</span>`
          }
        },
        {
          headerName: '纸箱数(预/实)',
          colId: 'cartonQuantity',
          field: 'cartonQuantity',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.totalCartonQuantity}</span>/<span ${
              data.totalActualCartonQuantity !== data.totalCartonQuantity ? 'style="color:red' : ''
            }">${data.totalActualCartonQuantity}</span>`
          }
        },
        {
          headerName: '订单号',
          colId: 'poNo',
          field: 'poNo',
          width: 150
        },
        {
          headerName: 'SKU编码',
          colId: 'itemNo',
          field: 'itemNo',
          width: 150
        },
        {
          headerName: 'SKU数量(预/实)',
          colId: 'itemQuantity',
          field: 'itemQuantity',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.totalItemQuantity}</span>/<span ${
              data.totalActualQuantity !== data.totalItemQuantity ? 'style="color:red' : ''
            }">${data.totalActualQuantity}</span>`
          }
        },
        {
          headerName: '总件数',
          colId: 'totalQuantity',
          field: 'totalQuantity',
          width: 150
        },
        {
          headerName: '长(预/实)(cm)',
          colId: 'length',
          field: 'length',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedLength}</span>/<span ">${data.length}</span>`
          }
        },
        {
          headerName: '宽(预/实)(cm)',
          colId: 'width',
          field: 'width',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedWidth}</span>/<span ">${data.width}</span>`
          }
        },
        {
          headerName: '高(预/实)(cm)',
          colId: 'height',
          field: 'height',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedHeight}</span>/<span ">${data.height}</span>`
          }
        },
        {
          headerName: '单件体积(预/实)(m³)',
          colId: 'unitCubage',
          field: 'unitCubage',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedUnitCubage}</span>/<span ">${data.unitCubage}</span>`
          }
        },
        {
          headerName: '单件毛重(预/实)(KG)',
          colId: 'unitGrossWeight',
          field: 'unitGrossWeight',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedUnitGrossWeight}</span>/<span ${
              data.unitGrossWeight !== data.estimatedUnitGrossWeight
                ? 'style="color:red'
                : ''
            }">${data.unitGrossWeight}</span>`
          }
        },
        {
          headerName: '总体积(预/实)(m³)',
          colId: 'cubage',
          field: 'cubage',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedCubage}</span>/<span ${
              data.cubage !== data.estimatedCubage ? 'style="color:red' : ''
            }">${data.cubage}</span>`
          }
        },
        {
          headerName: '总毛重(预/实)',
          colId: 'grossWeight',
          field: 'grossWeight',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `<span>${data.estimatedGrossWeight}</span>/<span ${
              data.grossWeight !== data.estimatedGrossWeight
                ? 'style="color:red'
                : ''
            }">${data.grossWeight}</span>`
          }
        },
        {
          headerName: '生产商',
          colId: 'producerName',
          field: 'producerName',
          width: 150
        },
        {
          headerName: '预计货好时间',
          colId: 'estimatedIncomeDate',
          field: 'estimatedIncomeDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '实际进仓时间',
          colId: 'warehouseInDate',
          field: 'warehouseInDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '实际出仓时间',
          colId: 'outDate',
          field: 'outDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '进仓编号',
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 150
        },
        {
          headerName: '注意事项',
          colId: 'matters',
          field: 'matters',
          width: 150
        },
        {
          headerName: '来源',
          colId: 'sourceFileName',
          field: 'sourceFileName',
          width: 150
        },
        {
          headerName: '箱号',
          colId: 'containerno',
          field: 'containerno',
          width: 150
        },
        {
          headerName: '箱型',
          colId: 'eqsize',
          field: 'eqsize',
          width: 150
        },
        {
          headerName: '箱种',
          colId: 'eqtype',
          field: 'eqtype',
          width: 150
        },
        {
          headerName: '封号',
          colId: 'sealno',
          field: 'sealno',
          width: 150
        },
        {
          headerName: '创建人',
          colId: 'createUserName',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '接收时间',
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '更新人',
          colId: 'modifyUserName',
          field: 'modifyUserName',
          width: 150
        },
        {
          headerName: '更新时间',
          colId: 'dateModified',
          field: 'dateModified',
          width: 150
        }
      ],
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      editRow: null,
      sumInfo: null
    }
  },
  watch: {
    warehouseInUuid(newVal, oldVal) {
      if (!newVal) {
        this.rowData = []
      }
      if (newVal && newVal !== oldVal) {
        this.fetchList()
      }
    }
  },
  methods: {
    fetchList() {
      this.loading = getLoading()
      const params = {
        warehouseInUuid: this.warehouseInUuid
      }
      Object.keys(this.form).forEach((key) => {
        if (this.form[key]) {
          params[key] = this.form[key]
        }
      })
      params.pageNum = this.filter.pageNum
      params.pageSize = this.filter.pageSize
      queryWarehouseInDetailPageable(params)
        .then((res) => {
          this.rowData = res.data.list
          this.filter.total = Number(res.data.total)
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
      queryPoPackageSumInfo({ warehouseInUuid: this.warehouseInUuid }).then(
        (res) => {
          const {
            sumCubage,
            sumEstimatedCubage,
            sumEstimatedGrossWeight,
            sumEstimatedQuantity,
            sumGrossWeight,
            sumQuantity
          } = res.data
          this.sumInfo = {
            sumCubage: sumCubage ? formatRoundNumber(sumCubage, 3) : 0,
            sumEstimatedCubage: sumEstimatedCubage
              ? formatRoundNumber(sumEstimatedCubage, 3)
              : 0,
            sumEstimatedGrossWeight: sumEstimatedGrossWeight
              ? formatRoundNumber(sumEstimatedGrossWeight, 3)
              : 0,
            sumEstimatedQuantity: sumEstimatedQuantity || 0,
            sumGrossWeight: sumGrossWeight
              ? formatRoundNumber(sumGrossWeight, 2)
              : 0,
            sumQuantity: sumQuantity || 0
          }
        }
      )
    },
    handleQuery(type = 0) {
      if (type !== 0) {
        this.filter.pageNum = 1
      }
      this.refreshBaseInfo()
      this.fetchList()
    },
    handleReset() {
      this.$refs['cargoDetalilFilter'].resetFields()
      this.form.poNo = ''
      this.$refs.poInput.inputValue = ''
      this.filter.pageNum = 1
      this.form.eqFlag = ''
      this.editRow = null
      this.fetchList()
    },
    totalClick() {
      this.form.eqFlag = this.form.eqFlag === 'notEq' ? '' : 'notEq'
      this.handleQuery(1)
    },
    handleAddCargoClose() {
      this.addCargoVisible = false
      this.handleQuery(1)
    },
    handleRemovePackage() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows().filter((item) => {
        return item.packageNo
      })
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要移除的包装')
        return
      }
      const packageNos = selectedRows.map((row) => row.packageNo)
      const packages = selectedRows.map((item) => {
        return {
          packageNo: item.packageNo,
          poPackageUuid: item.uuid,
          warehouseInDetailUuid: item.warehouseInDetailUuid
        }
      })
      const params = {
        warehouseInUuid: this.warehouseInUuid,
        packages
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('span', null, '包装号：'),
        h(
          'p',
          { style: 'margin: 0 10px;overflow-wrap: break-word;' },
          packageNos.join(',')
        ),
        h('p', { style: 'color: red' }, '是否确定移除以上包装？')
      ])
      this.$confirm(content, '移除货物', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        removePackageFromWarehouseIn(params)
          .then((res) => {
            this.$message.success('移除成功')
            this.loading.close()
            this.handleQuery(1)
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    oneKeyIncomeClose() {
      this.oneKeyIncomeVisible = false
      this.handleQuery(1)
    },
    handleWarehousIn() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows().filter((item) => {
        return item.packageNo
      })
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要进仓的包装')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error('一次只能对一个包装进行进仓操作')
        return
      }
      this.editRow = selectedRows[0]
      this.warehousingVisible = true
    },
    rowDoubleClicked(row) {
      console.log('click', row)
      this.editRow = row.data
      this.warehousingVisible = true
    },
    handleWarehousingClose() {
      this.warehousingVisible = false
      this.handleReset()
    },
    clearPackageIncome() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows().filter((item) => {
        return item.packageNo
      })
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要清除进仓信息的包装')
        return
      }
      const packageNos = selectedRows.map((row) => row.packageNo)
      const packages = selectedRows.map((item) => {
        return {
          packageNo: item.packageNo,
          poPackageUuid: item.uuid,
          warehouseInDetailUuid: item.warehouseInDetailUuid
        }
      })
      const params = {
        warehouseInUuid: this.warehouseInUuid,
        packages
      }
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [h('span', null, '包装号：')]),
        h(
          'p',
          { style: 'margin: 0 10px;overflow-wrap: break-word;' },
          packageNos.join(',')
        ),
        h('p', { style: 'color: red' }, '是否确定清除以上包装实际进仓数据？')
      ])
      this.$confirm(content, '清除进仓信息', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        clearPackageIncome(params)
          .then((res) => {
            this.$message.success('清除成功')
            this.loading.close()
            this.handleQuery(1)
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    importDialogClose() {
      this.packageImportVisible = false
      this.handleQuery(1)
    },
    exportTemplate() {
      const params = {
        warehouseInUuid: this.warehouseInUuid
      }
      exportNeedWarehouseInPackage(params).then((res) => {
        convertResToBlob(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.total {
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  &.notEq {
    background: #bdbdbd;
  }
}
</style>
